import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ABProvider } from '@guardian/ab-react';
import { getCypressSwitches } from '../experiments/cypress-switches';
import { getForcedParticipationsFromUrl } from '../lib/getAbUrlHash';
export const WithABProvider = ({ arrayOfTestObjects, abTestSwitches, pageIsSensitive, mvtId, ophanRecord, children, }) => {
    const windowHash = window?.location.hash;
    // Get the forced switches to use for when running within cypress
    // Is empty object if not in cypress
    const cypressAbSwitches = getCypressSwitches();
    return (_jsx(ABProvider, Object.assign({ arrayOfTestObjects: arrayOfTestObjects, abTestSwitches: {
            ...abTestSwitches,
            ...cypressAbSwitches, // by adding cypress switches below CAPI, we can override any production switch in Cypress
        }, pageIsSensitive: pageIsSensitive, mvtMaxValue: 1000000, mvtId: mvtId, ophanRecord: ophanRecord, forcedTestVariants: getForcedParticipationsFromUrl(windowHash) }, { children: children }), void 0));
};
